<template>
  <div>
    <div v-if="loading">
      <v-card outlined class="ma-4">
        <LoadingLine :title="'Tin nhắn đang được gửi đi'" :count="sendNoti.progress" />
      </v-card>
    </div>
    <v-card v-else outlined class="d-flex flex-column justify-center my-8 mx-16 pa-4">
      <p class="text--secondary">
        Đây là thao tác gửi tin nhắn tổng kết "Lương giáo viên" theo kỳ chi cụ thể. Các thông tin về "Lương giáo viên"
        của học sinh trong kỳ đóng sẽ được tổng hợp và gửi tới ứng dụng "LX-CBCNV" của giáo viên.
      </p>
      <p class="text--secondary">
        Nếu đã chắc chắn, bạn có thể tích vào ô <span class="font-weight-bold">[Xác nhận gửi tin]</span> bên dưới, sau
        đó nhấn nút <span class="font-weight-bold">[Gửi]</span>.
      </p>

      <v-checkbox v-model="checkbox" label="Xác nhận gửi tin" />
      <v-form v-show="checkbox" ref="form">
        <v-row class="">
          <v-col class="text--secondary mt-2 pb-0" cols="12" md="4"> Kỳ đóng <span class="error--text">*</span> </v-col>
          <v-col class="pb-0" cols="12" md="5">
            <AutocompleteSalaryPeriod
              :rules="[$rules.required]"
              v-model="period"
              label="Kỳ đóng"
              placeholder="Kỳ đóng"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text--secondary mt-2" cols="12" md="4">
            Hạn chi tương ứng <span class="error--text">*</span>
          </v-col>
          <v-col class="" cols="12" md="5">
            <DateIOSPicker label="Hạn đóng" :date.sync="deadline" outlined :rules="[$rules.date]" dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text--secondary mt-2" cols="12" md="4">
            Tin đính chính
          </v-col>
          <v-col class="" cols="12" md="5">
            <v-checkbox v-model="isReSummarized" dense />
          </v-col>
        </v-row>
        <v-row class="d-flex justify-end">
          <v-col class="d-flex justify-end mt-2 pb-0">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" class="btn-custom text-none">
                  Tùy chỉnh nhóm đối tượng nhận tin
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item class="list-item-title">
                  <v-list-item-title style="cursor: pointer" @click="() => openDialog('teacher')"
                    >Tìm kiếm và chọn giáo viên</v-list-item-title
                  >
                  <v-list-item-title style="cursor: pointer" @click="() => openDialog('group')"
                    >Nhóm lương</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <v-row class=" d-flex justify-end mb-1">
          <v-col class="d-flex justify-end">
            <span v-if="typeDialog === 'teacher'" class="d-flex justify-end grey--text">
              (Đã chọn {{ selectedTeachers.length }} giáo viên)</span
            >
            <span v-else-if="typeDialog === 'group'" class="disabled--text">
              (Đã chọn nhóm
              <strong>{{ groupChoice.title }}</strong
              >)
            </span>
            <span v-else></span>
          </v-col>
        </v-row>
      </v-form>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="!checkbox" @click="onSend" depressed color="primary" class="px-6 mt-4  white--text">
          Gửi
        </v-btn>
      </v-card-actions>
      <SelectGroupDialog ref="select-group-dialog" @choice-group="choiceGroup" />
      <SelectTeacherDialog ref="select-teacher-dialog" @choice-student="choiceGroup" />
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters, mapState } from 'vuex'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import LoadingLine from '@/components/basic/LoadingLine.vue'
import AutocompleteSalaryPeriod from '@/components/basic/input/AutocompleteSalaryPeriod.vue'
import SelectTeacherDialog from './select-teacher-dialog/index.vue'
import SelectGroupDialog from './SelectGroupDialog.vue'

const TYPE_DIALOG = {
  TEACHER: 'teacher',
  GROUP: 'group'
}

import { get } from 'lodash'
export default {
  components: {
    DateIOSPicker,
    LoadingLine,
    AutocompleteSalaryPeriod,
    SelectGroupDialog,
    SelectTeacherDialog
  },
  data() {
    return {
      checkbox: false,
      period: null,
      deadline: '',
      typeDialog: '',
      loading: false,
      interval: '',
      sendNoti: {},
      groupChoice: {},
      isReSummarized: false,
      TYPE_DIALOG
    }
  },
  async created() {
    this.date = moment().toISOString()
    let sendNoti = await this.getProgressTuitionFeePeriod({ status: 'running' })
    if (sendNoti.length > 0) {
      this.sendNoti = sendNoti[0]
      this.loading = true
      this.getProgress()
    }
  },
  computed: {
    ...mapState('PostCreateAuto', ['selectedTeachers']),
    ...mapGetters('auth', ['profile'])
  },
  methods: {
    ...mapActions('PostCreateAuto', ['sendTuitionFeePeriod', 'getProgressTuitionFeePeriod']),
    getProgress() {
      this.interval = setInterval(async () => {
        if (this.sendNoti.status === 'running') {
          let newProgress = await this.getProgressTuitionFeePeriod({ id: this.sendNoti.id })
          if (newProgress[0].status === 'finished') newProgress[0].progress = 99.9
          this.sendNoti = newProgress[0]
        } else if (this.sendNoti.status === 'finished') {
          this.$alert.success('Đã gửi tin nhắn "Lương giáo viên"')
          this.loading = false
          clearInterval(this.interval)
        }
      }, 2000)
    },
    openDialog(type) {
      this.typeDialog = type
      if (type === 'teacher') this.$refs['select-teacher-dialog'].open()
      else this.$refs['select-group-dialog'].open()
    },
    choiceGroup(value) {
      this.groupChoice = value
    },
    getIds(arr = []) {
      if (Array.isArray(arr) && arr.length) return arr.map(a => get(a, 'id')).filter(Boolean)
    },
    async onSend() {
      if (!this.$refs.form.validate()) return
      try {
        let metadata = { teachers: [], isReSummarized: this.isReSummarized }
        if (this.typeDialog === TYPE_DIALOG.TEACHER) metadata.teachers = this.getIds(this.selectedTeachers)
        this.loading = true
        let params = {
          status: 'running',
          salary_period: this.period.id,
          staff: this.profile.id,
          deadline: moment(this.deadline).format('DD/MM/YYYY')
        }
        if (this.typeDialog === TYPE_DIALOG.TEACHER) {
          params = { ...params, type: 'specific', metadata }
        } else {
          const selectType = this.typeDialog === TYPE_DIALOG.GROUP ? 'group' : 'all'
          params = {
            ...params,
            type: selectType,
            groupId: this.groupChoice.id
          }
        }
        this.sendNoti = await this.sendTuitionFeePeriod(params)
        this.getProgress()
      } catch (error) {
        this.$alert.error(`Đã xảy ra lỗi trong quá trình gửi tin nhắn! Lỗi: ${error}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-list-item .v-list-item__title {
  font-size: 14px;
}

.btn-custom {
  margin: 0 -15px;
  background-color: white !important;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 1px;
  line-height: 16px;
  color: #0d47a1 !important;
}

.btn-custom .btn-custom-lowercase {
  text-transform: lowercase;
  color: #0d47a1 !important;
  margin-left: -3px;
}
.btn-custom .btn-custom-lowercase:hover {
  color: aqua;
}
.custom.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none !important;
}

.custom.v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none !important;
}

.v-list-item__title {
  display: flex;
  justify-content: flex-end;
}

.list-item-title:hover {
  background-color: #ededed;
}
</style>
